/**
 * One line in the desktop app's log: a phase change or an announcement
 * decision (2026-10-18). Beta reports carry that log, so a silent clip shows
 * whether it played, was missing, silenced, muted or blocked. A no-op in a
 * browser, which has no app log.
 */
export function cabinNote(text) {
  try { window.electronAPI?.diagnostics?.note?.(String(text)); } catch { /* nothing to log to */ }
}
